import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";

import IndexDB from "./indexdb";

var WebStorage = function () {
  function WebStorage() {
    _classCallCheck(this, WebStorage);

    this.indexdb = IndexDB.getInstance();
  }

  _createClass(WebStorage, [{
    key: "set",
    value: function set(key, value) {
      var that = this;
      return that.indexdb.open().then(function () {
        return that.indexdb.set(key, value);
      });
    }
  }, {
    key: "get",
    value: function get(key) {
      var that = this;
      return that.indexdb.open().then(function () {
        return that.indexdb.get(key);
      });
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var that = this;
      return that.indexdb.open().then(function () {
        return that.indexdb.delete(key);
      });
    }
  }]);

  return WebStorage;
}();

var load = function load() {
  window.webStorage = window.webStorage || new WebStorage();
};
export default {
  load: load
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/web-storage.js
// module id = 1613
// module chunks = 2